/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".edit-field[_ngcontent-%COMP%]{display:-webkit-box;display:flex}.edit-field[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:first-child{margin-right:.5em;width:8rem!important}.edit-field[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:last-child{width:5rem!important}"];
export { styles as styles };
